import { hasCapability, type User } from "../base";

export const proxyPhone = {
  assign: (user: User) => hasCapability(user, "proxyPhone.assign"),
};
